<div
    class="upload-queue-overlay"
    *ngIf="isVisible"
    [class.expanded]="isExpanded"
    id="upload-queue-overlay"
>
    <div
        class="overlay-header"
        id="upload-queue-header"
        (click)="toggleExpanded()"
    >
        <div class="header-left">
            <div
                class="progress-circle"
                [ngClass]="displayJobs[0] ? 'state-' + displayJobs[0].displayState : ''"
                [style.--progress-percent]="displayJobs[0] ? getProgressPercent(displayJobs[0]) : 0"
            >
                <mat-icon class="state-icon" *ngIf="displayJobs[0]?.displayState === 'failed'">priority_high</mat-icon>
                <mat-icon class="state-icon" *ngIf="displayJobs[0]?.displayState === 'cancelled'">close</mat-icon>
            </div>
            <div class="header-text">
                <span class="title" *ngIf="isExpanded">{{
                    getOverlayTitle()
                }}</span>
                <span class="count" id="upload-queue-count">{{
                    displayJobs.length
                }}</span>
            </div>
        </div>
        <img
            class="toggle-icon"
            [src]="isExpanded ? 'assets/svg/upload-overlay/icon-minimize.svg' : 'assets/svg/upload-overlay/icon-expand.svg'"
            alt="toggle-upload-queue"
        />
    </div>
    <div class="overlay-body">
        <div
            class="upload-item"
            *ngFor="let job of displayJobs; trackBy: trackByJobId"
            data-testid="upload-queue-item"
        >
            <div
                class="progress-circle"
                [ngClass]="'state-' + job.displayState"
                [class.state-processing]="job.displayState === 'active' && job.status === 'processing'"
                [style.--progress-percent]="getProgressPercent(job)"
            >
                <span class="progress-percent" *ngIf="job.displayState === 'active' && job.status !== 'processing'">{{
                    getProgressPercent(job)
                }}%</span>
                <mat-icon class="state-icon" *ngIf="job.displayState === 'failed'">priority_high</mat-icon>
                <mat-icon class="state-icon" *ngIf="job.displayState === 'cancelled'">close</mat-icon>
            </div>
            <div class="upload-details">
                <div
                    class="target"
                    [title]="getPlainTargetLabel(job)"
                    [innerHTML]="getTargetLabel(job)"
                ></div>
                <div class="status-row">
                    <span
                        class="status-label"
                        [class.status-queued]="job.status === 'queued'"
                        [class.status-uploading]="job.status === 'uploading'"
                        [class.status-processing]="job.status === 'processing'"
                        [class.status-failed]="job.displayState === 'failed'"
                        [class.status-cancelled]="job.displayState === 'cancelled'"
                        *ngIf="getStatusLabel(job)"
                    >
                        {{ getStatusLabel(job) }}
                        <span *ngIf="getQueuePosition(job) > 0">
                            ({{ getQueuePosition(job) }} {{ 'imgDb.upload.overlay.status.inQueue' | translate }})
                        </span>
                    </span>
                    <span class="counts" *ngIf="job.status !== 'processing'">
                        {{ job.processedCount }} / {{ job.totalCount }}
                    </span>
                </div>
            </div>
            <button
                class="cancel-button"
                data-testid="upload-queue-cancel"
                (click)="openCancelDialog(job)"
                *ngIf="!isJobCompleted(job) && job.status !== 'processing'"
                [title]="'imgDb.upload.cancelDialog.cancelButton' | translate"
            >
                <img
                    class="icon-default"
                    src="assets/svg/reusable-svg/icon-cancel.svg"
                    alt="cancel"
                />
                <img
                    class="icon-hover"
                    src="assets/svg/reusable-svg/icon-cancel-hover.svg"
                    alt="cancel"
                />
            </button>
        </div>
    </div>
</div>
